(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-riding-guides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-guide-carousel')) {
  customElements.define('ls-guide-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previous = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.count = this.querySelector('[data-carousel-count]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    cards() {
      return Array.from(this.track.children);
    }
    position() {
      const cards = this.cards();
      const left = this.track.getBoundingClientRect().left + 4;
      let index = 0;
      let closest = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect().left - left);
        if (distance < closest) { closest = distance; index = i; }
      });
      return index;
    }
    move(direction) {
      const cards = this.cards();
      if (cards.length < 2) return;
      const step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const cards = this.cards();
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      this.count.textContent = cards.length ? (this.position() + 1) + ' / ' + cards.length : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-shop-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ls-directory-carousel')) {
  customElements.define('ls-directory-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previous = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.count = this.querySelector('[data-carousel-count]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    cards() {
      return Array.from(this.track.children);
    }
    position() {
      const cards = this.cards();
      const left = this.track.getBoundingClientRect().left + 4;
      let index = 0;
      let closest = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect().left - left);
        if (distance < closest) { closest = distance; index = i; }
      });
      if (this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2) index = cards.length - 1;
      return index;
    }
    move(direction) {
      const cards = this.cards();
      const target = cards[Math.max(0, Math.min(cards.length - 1, this.position() + direction))];
      if (!target) return;
      const offset = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 4;
      this.track.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const cards = this.cards();
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      this.count.textContent = cards.length ? (this.position() + 1) + ' / ' + cards.length : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
